// replace error messages numeric values for [NUMBER_PLACEHOLDER] to avoid dynamic messages
import moment from 'moment'

import { TIMESHEET_VIEWS } from '../constants/glimpseViews'

export const ERRORS_TO_FILTER = [
  'TimesheeIsAlreadyApprovedError: No error message',
  'Error: timeout of [NUMBER_PLACEHOLDER]ms exceeded',
  'Error: Network error: Response not successful: Received status code [NUMBER_PLACEHOLDER]',
  'Error: Popup closed',
  'Error: Popup window closed',
]

const now = moment()
  .utc()
  .toISOString()

export const initialReminderSettings = {
  shouldRemind: false,
  weekDays: {
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
  },
  timeFrom: new Date(now),
  timeTo: new Date(now),
  periodInMinutes: 30,
}

export const initialUserSettings = {
  favoriteProjectIds: [],
  defaultProjectId: null,
}

export const initialState = {
  view: TIMESHEET_VIEWS.TIMELINE,
  viewPeriod: 'day',
  updateAvailable: false,
  appVersionNumber: '',
  modal: {
    open: false,
    message: '',
    title: '',
  },
  hasUserGotStarted: true,
  isRecurrentSyncInProgress: false,
  isSubmitInProgress: false,
  isTimesheetLoading: false,
  delegateAccesses: [],
  selectedDelegateId: null,
  selectedDate: new Date(),
  userSettings: initialUserSettings,
  currentEditableEntry: {},
  initialCurrentEditableEntry: {},
  isAddAllEntriesFromEventsModalOpen: false,
  isAllEventsButton: false,
  isNoFreeGapModalOpen: false,
  successCsvInfoTotal: {},
  failedCsvInfoTotal: {},
  csvUploadData: {
    isCSVUploadInProgress: false,
    csvsToUploadTotal: 0,
    csvUploadCount: 0,
  },
  csvActionButtonsBlocked: false,
  areEventsBeingAdded: false,
  isDelegateAccessModalFromMenuOpen: false,
  isIssueReportModalFromMenuOpen: false,
  isReportPageShown: false,
  reminderSettings: initialReminderSettings,
  hasOutlookEverSynced: false,
}
